import { NgOptimizedImage } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { TranslocoDirective } from '@jsverse/transloco';

@Component({
    selector: 'app-resource-not-found-component',
    imports: [RouterLink, TranslocoDirective, NgOptimizedImage],
    templateUrl: './resource-not-found.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './resource-not-found.component.scss',
})
export class ResourceNotFoundComponent {}
